<!-- 添加附件 -->
<template>
  <div class="affix-section">
    <a-upload
      :multiple="false"
      :custom-request="_uploadFile"
      :remove="handleRemove"
      :fileList="fileList"
    >
      <a-button>
        <a-icon type="upload" />
        添加附件
      </a-button>
    </a-upload>
  </div>
</template>
<script>
import { uploadFile } from '../api'

export default {
  data() {
    return {
      fileList: [],
      attachmentIds: [],
    }
  },
  props: ['suffixs', 'maxSize'],
  mounted() {},
  methods: {
    async _uploadFile(file) {
      this.loading = true
      const crtFile = file.file
      const formData = new FormData()
      formData.append('file', crtFile)
      try {
        const { data } = await uploadFile(formData)
        this.attachmentIds = [data]
        this.fileList = [
          {
            uid: crtFile.uid,
            name: crtFile.name,
            status: 'done',
          },
        ]
      } catch (error) {
        console.error(error)
      }
    },
    handleRemove() {
      this.fileList.splice(0, Infinity)
    },
    // 暴露给父组件的方法
    getAttachmentIds() {
      return this.attachmentIds
    },
  },
}
</script>

<style lang="less" scoped></style>
